import { render, staticRenderFns } from "./GreenFinanceAward2025.vue?vue&type=template&id=92c82fbc&scoped=true&"
import script from "./GreenFinanceAward2025.vue?vue&type=script&lang=js&"
export * from "./GreenFinanceAward2025.vue?vue&type=script&lang=js&"
import style0 from "./GreenFinanceAward2025.vue?vue&type=style&index=0&id=92c82fbc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c82fbc",
  null
  
)

export default component.exports